var _rect, _rect2, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgAvalanche = function SvgAvalanche(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 50,
    fill: "#E84142"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 50,
    fill: "url(#E84142)",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.988 28.301h4.035c.95 0 1.425 0 1.85-.117a3.047 3.047 0 0 0 1.24-.72c.325-.31.558-.718 1.019-1.524l.014-.025 5.233-9.252c.465-.812.695-1.22.797-1.65a3.032 3.032 0 0 0 0-1.42c-.101-.425-.333-.831-.791-1.631l-.01-.018-2.049-3.576c-.424-.746-.639-1.119-.91-1.257a1.028 1.028 0 0 0-.929 0c-.27.138-.485.51-.91 1.257L6.615 25.93c-.42.735-.629 1.103-.613 1.404.02.328.189.624.465.803.255.163.674.163 1.522.163Zm20.009 0h-5.783c-.853 0-1.282 0-1.532-.163a1.035 1.035 0 0 1-.465-.808c-.015-.298.196-.663.618-1.392l.01-.017 2.886-4.955c.424-.73.639-1.093.904-1.231.291-.148.634-.148.925 0 .264.134.47.481.876 1.169l.033.057 2.897 4.955.005.01.037.062c.401.692.606 1.046.591 1.338a1.022 1.022 0 0 1-.465.807c-.255.168-.684.168-1.537.168Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 18 -18 0 18 18)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E84142"
  })))));
};
export default SvgAvalanche;